import React from 'react';
import {KeyboardAvoidingView, StyleSheet, View} from 'react-native';

import {useModalDimensions} from '../../hooks/useModalDimensions';
import theme from '../../style/theme';

import CrossPlatformModal from './CrossPlatformModal';
import Text from './Text';

function Modal({
  onBackdropPress,
  children,
  isVisible,
  title,
}: {
  onBackdropPress?: () => void;
  children: React.ReactNode;
  isVisible: boolean;
  title: string;
}) {
  const {containerStyle: modalContainerStyle} = useModalDimensions({size: 'small'});

  return (
    <CrossPlatformModal
      testID="ui-controls-modal"
      onBackdropPress={onBackdropPress}
      isVisible={isVisible}
      style={styles.main}
      hasBackdrop
      backdropColor="black"
      backdropOpacity={0.5}
      onBackButtonPress={onBackdropPress}>
      <KeyboardAvoidingView
        behavior="position"
        style={{
          ...modalContainerStyle,
          paddingBottom: 20,
        }}
        contentContainerStyle={{
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <View style={styles.modal}>
          <Text style={styles.title}>{title}</Text>
          {children}
        </View>
      </KeyboardAvoidingView>
    </CrossPlatformModal>
  );
}

export default Modal;

const styles = StyleSheet.create({
  main: {
    alignItems: 'center',
  },
  modal: {
    backgroundColor: 'white',
    paddingHorizontal: 32,
    paddingVertical: 16,
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'grey',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: theme.colour.text.heading.primary,
    textAlign: 'center',
  },
});
